module.exports = __webpack_public_path__ + "img/lxwmbg.f754ea66.png";